import styled from "styled-components"
import { ArrowType, ArrowProps } from "./arrow.component"

export const Svg = styled.svg<Pick<ArrowProps, "arrowType">>`
  height: 14px;
  width: 12px;
  transform: rotate(
    ${({ arrowType }) => (arrowType === ArrowType.Next ? "180deg" : "none")}
  );
`
